const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.referme.pixenstudio.in";
// console.log("Current API BASE_URL:", BASE_URL);
export const API_BASE_URL = BASE_URL;

// Google OAuth Client ID - from environment variable
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const API = {
  GET_PDFS: `${BASE_URL}/getpdfs`,
  GET_PDF_BY_EDIT_ID: (editId) => `${BASE_URL}/pdf/${editId}`,
  GET_PDF_BY_ID: (id) => `${BASE_URL}/pdf/${id}`,
  DOWNLOAD_PDF: (id) => `${BASE_URL}/pdf/${id}/download`,
  UPLOAD: `${BASE_URL}/Upload`,
  LOGIN: `${BASE_URL}/login`,
  GOOGLE_LOGIN: `${BASE_URL}/auth/google`,
  REGISTER: `${BASE_URL}/register`,
  SEND_OTP: `${BASE_URL}/send-otp`,
  VERIFY_OTP: `${BASE_URL}/verify-otp`,
  SEND_RESET_PASSWORD_LINK: `${BASE_URL}/send-reset-password-link`,
  RESET_PASSWORD: `${BASE_URL}/reset-password`,
  AUTH_CHECK: `${BASE_URL}/auth/check`,
  AUTH_LOGOUT: `${BASE_URL}/auth/logout`,
  AUTH_PROFILE: `${BASE_URL}/auth/profile`,
  AUTH_UPDATE_PROFILE: `${BASE_URL}/auth/update-profile`,
  ACCOUNT_TYPE: `${BASE_URL}/auth/account-type`,
  GET_ALL_PAYMENTS: `${BASE_URL}/admin/payments`,
  GET_ALL_USERS: `${BASE_URL}/admin/users`,
  EXPORT_USERS: `${BASE_URL}/admin/users/export`,
  GET_TOTAL_DOWNLOADS: `${BASE_URL}/stats/total-downloads`,
  GET_ALL_VIDEO: `${BASE_URL}/video/allvideo`,
  GET_VIDEO_BY_ID: `${BASE_URL}/video`,
  ADD_VIDEO: `${BASE_URL}/video/add`,
  UPDATE_VIDEO_BY_ID: `${BASE_URL}/video`,
  GET_DATA_LOOKUP: `${BASE_URL}/lookup`,
};

export const branchEndpoint = {
  GET_ALL_BRANCHES: `${BASE_URL}/branches`,
  ADD_BRANCH: `${BASE_URL}/branch/add`,
};

export const subjectEndpoint = {
  GET_ALL_SUBJECTS: `${BASE_URL}/subjects`,
  GET_SUBJECTS_BY_BRANCH: (branchId) =>
    `${BASE_URL}/subjects/branch/${branchId}`,
  ADD_SUBJECT: (branchId) => `${BASE_URL}/subject/add/${branchId}`,
};

export const unitEndpoint = {
  GET_UNITS_BY_SUBJECT: (subjectId) => `${BASE_URL}/units/subject/${subjectId}`,
  ADD_UNIT: (subjectId) => `${BASE_URL}/unit/add/${subjectId}`,
  UPDATE_UNIT: (id) => `${BASE_URL}/unit/${id}`,
  DELETE_UNIT: (id) => `${BASE_URL}/unit/${id}`,
};

export const settingsEndpoints = {
  GET_SETTINGS: `${BASE_URL}/settings`,
  UPDATE_SETTINGS: `${BASE_URL}/settings`,
};

export const paymentEndpoint = {
  CREATE_ORDER: `${BASE_URL}/payment/create-order`,
  VERIFY_PAYMENT: `${BASE_URL}/payment/verify-payment`,
};
